import CookieIcon from './icons/CookieIcon';
import { getGdpr, IGdpr, setGdpr, startGoogleAnalytics } from './gdpr-provider';
import { useState } from 'react';
import ConsentPopup from './ConsentPopup';

const ConsentBanner = () => {

    const [data, setData] = useState<IGdpr|null>(getGdpr());
    const [consentPopupShown, setConsentPopupShown] = useState(false);

    /**
     * accept all cookies
     */
    const accept = () => {

        const updatedData = {
            accept: true,
        };

        setGdpr(updatedData);
        setData(updatedData);

        startGoogleAnalytics();
    };

    const customize = () => {
        setConsentPopupShown(true);
    };

    const showPopup = data === null;

    return (
        <>
            {
                showPopup &&
                <div className="fixed z-50 left-2 right-2 bottom-2 mx-auto md:mx-0 bg-gray-700 text-gray-100 rounded w-96 shadow" style={{
                    maxWidth: '95%',
                }}>
                    <div className="p-4">
                        <p className="flex items-center mb-4">
                            <CookieIcon />
                            <span className="ml-4 text-xl">Your Privacy</span>
                        </p>
                        <div className="text-sm">
                            <p className="mb-4">By clicking “Accept all cookies”, you agree this website can store cookies on your device and disclose information in accordance with our <a href="/privacy/privacy-policy.html" title="" className="underline">Privacy Policy</a>.</p>
                            <p className="flex justify-center items-center">

                                <button
                                    type="button"
                                    className="bg-cyan-600 px-4 py-2 rounded mr-2"
                                    onClick={ accept }>Accept all cookies</button>

                                <button
                                    type="button"
                                    className="bg-gray-300 px-4 py-2 rounded mr-2 text-cyan-800"
                                    onClick={ customize }>Customize settings</button>
                            </p>
                        </div>
                    </div>
                </div>
            }

            {
                consentPopupShown &&
                <ConsentPopup
                    setPopupShown={ setConsentPopupShown }
                    setData={ setData }
                />
            }
        </>
    )
};

export default ConsentBanner;